<template>
  <h1>404</h1>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// P404.vue?f1c02c18